import { render, staticRenderFns } from "./DeleteOrganisationModal.vue?vue&type=template&id=a92f035e&scoped=true"
import script from "./DeleteOrganisationModal.vue?vue&type=script&lang=js"
export * from "./DeleteOrganisationModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteOrganisationModal.vue?vue&type=style&index=0&id=a92f035e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f035e",
  null
  
)

export default component.exports